import React from 'react'
import { useDispatch } from 'react-redux'
import { Button, Form, Modal } from 'antd'
import { setProject } from '../../../store/projects'
import ProjectSelector from '../../ProjectSelector'

const ChooseProjectModal = ({ showModal, onChancel, onFinish }) => {
  const dispatch = useDispatch()
  const [form] = Form.useForm()

  const onChancelClick = () => {
    onChancel()
    form.resetFields()
  }

  const onFinishCallback = ({ project }) => {
    dispatch(
      setProject({
        project,
      })
    )
    onFinish(project)
    form.resetFields()
  }

  return (
    <Modal
      title="Выбрать проект"
      visible={showModal}
      onCancel={onChancelClick}
      footer={[
        <Button key="back" onClick={onChancelClick}>
          Отмена
        </Button>,
        <Button key="save" type="primary" onClick={() => form.submit()}>
          Выбрать
        </Button>,
      ]}
    >
      <Form
        name="choose-project"
        initialValues={{ remember: true }}
        autoComplete="off"
        layout="vertical"
        onFinish={onFinishCallback}
        form={form}
        size="large"
      >
        <Form.Item name="project" rules={[{ required: true, message: 'Выберите проект' }]}>
          <ProjectSelector />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ChooseProjectModal
